/*
 * Initializes Swiper on .dc-about-us__award-list (the 3 ranking/award
 * badges at the bottom of the page). Swiper itself is installed as a theme
 * asset (swiper-bundle.min.js) and loaded by sections/dc-about-us.liquid
 * before this file, so window.Swiper is already available here — same
 * setup as assets/dc-hero-banner.js.
 *
 * PC keeps the original plain 3-up row (Swiper's own breakpoints option
 * disables touch/drag and shows all 3 slides with no partial peek there);
 * mobile becomes a swipeable carousel with the next card peeking in from
 * the edge, matching the MO sample.
 *
 * PC's spaceBetween is 0 here on purpose — Swiper's gap only accepts a
 * plain px number, not a vw value, so it can't scale fluidly like the rest
 * of the page. The actual PC gap is done in plain CSS instead (see
 * .dc-about-us__award-list rules in sections/dc-about-us.liquid), which
 * does support vw; that's safe only because the PC row never swipes.
 *
 * Mobile's slide width is set via CSS on .swiper-slide (slidesPerView:
 * 'auto' leaves that width alone) and its gap is a 60/860 ratio, but since
 * spaceBetween is real touch/drag math here (unlike PC's static row), it
 * can't be swapped for the CSS-`gap` trick — Swiper needs its own accurate
 * px value to map drag distance to visual movement correctly. So it's
 * computed from the swiper's actual current width instead of hardcoded,
 * keeping it proportionally accurate at any viewport size without needing
 * vw.
 */
const MOBILE_BREAKPOINT = 768;
const MOBILE_GAP_RATIO = 60 / 860;

// Mobile prev/next arrows (sections/dc-about-us.liquid): vertically
// centered on the award image, whose height depends on the viewport and on
// when the image loads — so the top is measured, not hardcoded.
function placeArrows(el) {
  const media = el.querySelector('.dc-about-us__award-media');
  if (!media) return;
  el.style.setProperty('--dc-award-arrow-top', media.offsetTop + media.offsetHeight / 2 + 'px');
}

function initAwardList(el) {
  const swiper = new window.Swiper(el, {
    slidesPerView: 'auto',
    spaceBetween: el.offsetWidth * MOBILE_GAP_RATIO,
    freeMode: true,
    navigation: {
      prevEl: el.querySelector('.dc-about-us__award-arrow--prev'),
      nextEl: el.querySelector('.dc-about-us__award-arrow--next'),
    },
    on: {
      init(instance) {
        placeArrows(instance.el);
      },
      resize(instance) {
        if (window.innerWidth < MOBILE_BREAKPOINT) {
          instance.params.spaceBetween = instance.el.offsetWidth * MOBILE_GAP_RATIO;
          instance.update();
        }
        placeArrows(instance.el);
      },
    },
    breakpoints: {
      [MOBILE_BREAKPOINT]: {
        slidesPerView: 3,
        spaceBetween: 0,
        allowTouchMove: false,
        freeMode: false,
      },
    },
  });
  el.querySelectorAll('.dc-about-us__award-media img').forEach((img) => {
    if (!img.complete) img.addEventListener('load', () => placeArrows(el), { once: true });
  });
  return swiper;
}

function ready(fn) {
  if (document.readyState !== 'loading') fn();
  else document.addEventListener('DOMContentLoaded', fn);
}

ready(() => {
  document.querySelectorAll('.dc-about-us__award-list.swiper').forEach(initAwardList);
});
